export default __webpack_public_path__ + "static/media/3d_gallery.cd0ebaee.jpeg";